export default __webpack_public_path__ + "static/media/diners-club.d448417b.svg";